var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home",class:{ active: _vm.type != 2 && _vm.type != 3, active2: _vm.type == 2, active3: _vm.type == 3 }},[_c('div',{staticClass:"pdfCom"},[_c('vue-pdf',{attrs:{"src":_vm.pdfSrc}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }